import { render, staticRenderFns } from "./HelpWithMyOrderUsed.vue?vue&type=template&id=1971e1ee&scoped=true"
import script from "./HelpWithMyOrderUsed.vue?vue&type=script&lang=js"
export * from "./HelpWithMyOrderUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1971e1ee",
  null
  
)

export default component.exports